'use client'

import { useEffect, useState } from 'react'
import { clientTextTranslator } from 'app/lib/clientServerTranslate'
import Footer from './Footer'
import WidgetWrapper from 'components/WidgetWrapper'
import Link from 'components/shared/link'

interface ClientLandingFooterProps {
    lang: string
    config: IDomainConfig
    isHostDomain: boolean
    removeController?: boolean
}

const ClientLandingFooter: React.FC<ClientLandingFooterProps> = ({ lang, config, isHostDomain, removeController }) => {
    const [texts, setTexts] = useState<{
        privacyPolicy: string
        termsOfService: string
        cookiesPolicy: string
        home: string
        aboutUs: string
        contactUs: string
        cuttingEdgeESportsSolutions: string
        legal: string
        info: string
    } | null>(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const loadTexts = async () => {
            try {
                const [
                    privacyPolicy,
                    termsOfService,
                    cookiesPolicy,
                    home,
                    aboutUs,
                    contactUs,
                    cuttingEdgeESportsSolutions,
                    legal,
                    info
                ] = await Promise.all([
                    clientTextTranslator(lang, 'privacyPolicy'),
                    clientTextTranslator(lang, 'termsOfService'),
                    clientTextTranslator(lang, 'cookiesPolicy'),
                    clientTextTranslator(lang, 'home'),
                    clientTextTranslator(lang, 'aboutUs'),
                    clientTextTranslator(lang, 'contactUs'),
                    clientTextTranslator(lang, 'cuttingEdgeESportsSolutions'),
                    clientTextTranslator(lang, 'legal'),
                    clientTextTranslator(lang, 'info')
                ])

                setTexts({
                    privacyPolicy,
                    termsOfService,
                    cookiesPolicy,
                    home,
                    aboutUs,
                    contactUs,
                    cuttingEdgeESportsSolutions,
                    legal,
                    info
                })
            } catch (error) {
                console.error('Failed to load translations:', error)
                // Fallback texts
                setTexts({
                    privacyPolicy: 'Privacy Policy',
                    termsOfService: 'Terms of Service',
                    cookiesPolicy: 'Cookies Policy',
                    home: 'Home',
                    aboutUs: 'About Us',
                    contactUs: 'Contact Us',
                    cuttingEdgeESportsSolutions: 'Cutting Edge ESports Solutions',
                    legal: 'Legal',
                    info: 'Info'
                })
            } finally {
                setIsLoading(false)
            }
        }

        loadTexts()
    }, [lang])

    if (isLoading || !texts) {
        return (
            <WidgetWrapper>
                <footer className='flex flex-col w-full lg:h-[420px] h-fit mt-16 px-3 md:px-6 relative'>
                    <nav aria-label='Policies' className='flex flex-wrap justify-center gap-4 py-8'>
                        <Link href='/info/privacy-policy' className='hover:underline'>
                            Privacy Policy
                        </Link>
                        <Link href='/info/tos' className='hover:underline'>
                            Terms of Service
                        </Link>
                        <Link href='/info/cookies-policy' className='hover:underline'>
                            Cookies Policy
                        </Link>
                    </nav>
                </footer>
            </WidgetWrapper>
        )
    }

    return <Footer texts={texts} config={config} isHostDomain={isHostDomain} removeController={removeController} />
}

export default ClientLandingFooter
